export const selectPricing = (reduxState) => reduxState.payment.pricing;
